/**
 * Medidas de toda tarjeta o bloque del ERP.
 *
 * Son las de la skill de diseño de NARA (`nara-presentacion`, identidad.md,
 * «Medidas del patrón», tomadas de Venta diaria de Turismo) y las mismas que
 * `tarjeta` en `nara-ui/src/tokens.js`. El ERP todavía no usa nara-ui: esta
 * es su copia. Si cambian allá, se cambian aquí.
 *
 * Las tarjetas se veían enormes (2026-11-01): relleno de 20 a 24 px, radio de
 * 10 a 15 px, borde, títulos de 16 px y cifras de 20 px. Un bloque no pasa de
 * lo que necesita su contenido.
 *
 * Los valores van en px escritos como texto ('6px') a propósito: un número en
 * `borderRadius` se multiplica por el radio del tema (10) y un 1.5 daba 15 px.
 */
export const TARJETA = {
  radio: '6px',
  radioInterno: '4px',              // lo de adentro (tarjetitas blancas)
  relleno: { xs: 1, md: 1.25 },     // 8 px en celular, 10 px en computador
  separacion: 1,                    // 8 px entre bloques y entre filas
  // Fondo común de las tarjetas con chips o botones de color: uno solo para
  // todas, que no compite con ningún tono (`tarjeta.fondoInteractivo` de
  // nara-ui, en claro). Las de cifra o estado sin chips llevan su color.
  fondoInteractivo: '#d6e6ea',
};

/** Bloque blanco (gráfico, formulario, datos): sin borde ni sombra. */
export const BLOQUE = {
  p: TARJETA.relleno, borderRadius: TARJETA.radio, bgcolor: 'background.paper',
  border: 'none', boxShadow: 'none', minWidth: 0,
};

/** El contenedor de una tabla: sin relleno, para que la tabla llegue al borde. */
export const CONTENEDOR_TABLA = {
  borderRadius: TARJETA.radio, overflow: 'hidden', bgcolor: 'background.paper',
  border: 'none', boxShadow: 'none',
};

/** Tarjeta con chips o botones de color adentro: el fondo común. */
export const TARJETA_INTERACTIVA = {
  p: TARJETA.relleno, borderRadius: TARJETA.radio, bgcolor: TARJETA.fondoInteractivo,
  border: 'none', boxShadow: 'none', minWidth: 0,
};

/** Lo de adentro de un bloque de color: tarjetita blanca. */
export const TARJETITA = {
  px: 1, py: 0.75, borderRadius: TARJETA.radioInterno, bgcolor: 'background.paper',
};

/** Título de un bloque (no cifra): 14 px, peso 800. */
export const TITULO_BLOQUE = {
  fontSize: { xs: 14, md: 13.5 }, fontWeight: 800, color: '#1e293b', lineHeight: 1.3,
};

/** Etiqueta de un bloque: 9 px, mayúsculas. */
export const ETIQUETA_BLOQUE = {
  fontSize: { xs: 9, lg: 8.5 }, fontWeight: 700, textTransform: 'uppercase',
  letterSpacing: 0.3, lineHeight: 1.2,
};
